"use client";

import { useSyncExternalStore } from "react";

let visible = false;
let live = false;
const listeners = new Set<() => void>();

export function setMessengerLive(next: boolean) {
  live = next;
}

export function messengerLive(): boolean {
  return live;
}

export function setMessengerVisible(next: boolean) {
  if (visible === next) return;
  visible = next;
  listeners.forEach((notify) => notify());
}

function subscribe(notify: () => void) {
  listeners.add(notify);
  return () => { listeners.delete(notify); };
}

export function useMessengerVisible() {
  return useSyncExternalStore(subscribe, () => visible, () => false);
}

let launcherHeld = false;
const launcherListeners = new Set<() => void>();

export function setLauncherHeld(next: boolean) {
  if (launcherHeld === next) return;
  launcherHeld = next;
  launcherListeners.forEach((notify) => notify());
}

function subscribeLauncher(notify: () => void) {
  launcherListeners.add(notify);
  return () => { launcherListeners.delete(notify); };
}

export function useLauncherHeld() {
  return useSyncExternalStore(subscribeLauncher, () => launcherHeld, () => false);
}
